/**
 * 颜色（条件）变化动画
 */
import fvAnimation from "./fvAnimation"
export default class fvColorTransform extends fvAnimation {
    constructor(shape){
        super(shape,"fvColorTransform");
        this.sizeFunction = AsyncFunction("return (" + this.expression+ ") > 0 ? " + this.expression + ":false");
        this.getData();
    }

    async getData(){
        this.result = await this.executionScript(this.sizeFunction);
    }

    run(canvas,value){
        //if(value == false) return;
        this.getData();
        // 表达式为真 true  ，color[0] 否则color[1]
        var index = this.result ? 0 : 1; 
        if(this.shape.fctype == "fvLineObj" || this.shape.fctype == "fvPolylineObj"){
            this.shape.borderColor = this.changeColor[index];   
        }else if(this.shape.fctype == "fvPipeObj"){
            this.shape.outsideColor = this.changeColor[index];
        }else{
            this.shape.color = this.changeColor[index];
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvColorTransform.js